<template>
  <div class="pagination-wrap">
    <el-pagination
      @current-change="handleCurrentChange"
	  @size-change = "handleSizeChange"
      :hide-on-single-page="value"
      :current-page="currentPage"
      :page-size="+pageSize"
	  :page-sizes="[5,10,20,50]"
      layout="prev, pager, next ,jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: 'commonpagination',
  props: {
    total: {
      required: true
    },
    page_size: {
      required: true,
      type: [Number, String],
      default: 50,
    },
    page_index: {
      default:  1,
    }
  },
	data() {
	  return {
      value: false,
      pageSize: this.page_size,
	  };
	},
  computed: {
    currentPage() {
      return  this.page_index
    }
  },
  mounted() {
    //首次加载只有一页数据时 不显示分页器
    let totalPage = Math.ceil(this.total/this.page_size);
      if (totalPage <=1) this.value = true;
  },
	methods: {
	  handleCurrentChange(val) {
	  	this.$emit('page-change', val)
	  },
	  handleSizeChange(val){
		  console.log(val);
		  this.$emit('size-change', val)
	  }
	},
  watch: {
  }
}
</script>

<style lang="less" scoped>
/deep/.el-pagination{
  text-align: center;
  margin-top: 20px;
}
/deep/.el-pager li.active{
    background-color : #1890ff;
    color : #fff;
    border-radius: 5px;
  }
</style>
